import { Button } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '@/contexts/ThemeContext';
import { trackThemeToggle } from '@/utils/analytics';

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  const handleToggle = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    trackThemeToggle(newTheme);
    toggleTheme();
  };

  return (
    <Button
      type="text"
      icon={theme === 'light' ? <BulbFilled /> : <BulbOutlined />}
      onClick={handleToggle}
      className="theme-toggle-btn"
      size="large"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '48px',
        height: '48px',
        borderRadius: '12px',
      }}
      title={theme === 'light' ? 'Switch to Dark Theme' : 'Switch to Light Theme'}
    />
  );
}

export default ThemeToggle;

